var map = {
	"./Bear.mp3": 3836,
	"./Cat.mp3": 3400,
	"./Chicken.mp3": 5462,
	"./Cow.mp3": 2616,
	"./DEER.mp3": 7798,
	"./Dog.mp3": 3570,
	"./Duck.mp3": 8700,
	"./Frog.mp3": 2265,
	"./Giraffe.mp3": 6389,
	"./Goat.mp3": 1639,
	"./Horse.mp3": 247,
	"./Monkey.mp3": 5345,
	"./Mouse.mp3": 9326,
	"./Pig.mp3": 9877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2221;